import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import type { Subscription } from '../types'

interface SubscriptionExpiredBannerProps {
  subscription: Subscription
}

export function SubscriptionExpiredBanner({ subscription }: SubscriptionExpiredBannerProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div
      role="status"
      className="flex items-center justify-between rounded-lg border border-red-300 bg-red-50 px-4 py-3 text-red-900"
    >
      <p className="text-sm font-medium">
        {subscription.status === 'past_due'
          ? t('subscription.past_due_banner')
          : t('subscription.expired_banner')}
      </p>
      <button
        onClick={() => navigate('/subscription/manage')}
        className="ml-4 min-h-[44px] rounded-md bg-red-600 px-4 text-sm font-semibold text-white transition-colors hover:bg-red-700"
      >
        {t('subscription.reactivate')}
      </button>
    </div>
  )
}
